<app-wizard-modal [isLoading]="isDataLoading"
                  [vertical]="false"
                  [isReadOnlyMode]="isReadOnly"
                  [canDelete]="isEditMode && shouldRenderModifiers && !isPartNumberInUse"
                  [canDeleteTooltipText]="canDeleteTooltipText"
                  [hasDelete] = hasPermission()
                  [isEditMode]="isEditMode"
                  [isViewMode]="isViewMode"
                  (stepChange)="onWizardStepChange($event)"
                  (submit)="onWizardSubmit()"
                  (delete)="onWizardDelete()"
                  (cancel)="onWizardCancel()"
                  (modalOpened)="onModalOpened()">
    <app-wizard-title>
        <ng-container modal-header>
            <h5 class="modal-title"
                *ngIf="!isEditMode; else editTitle">{{ 'admin.partNumbers.create-modal.title' | translate }}</h5>
            <ng-template #editTitle>
                <h5 class="modal-title">{{ 'admin.partNumbers.update-modal.title' | translate }}</h5>
            </ng-template>
        </ng-container>
    </app-wizard-title>
    <app-wizard-step [canContinue]="isWizardOpened && partNumberDetailsValid">
        <ng-template #title>{{ 'admin.partNumbers.form.sections.details' | translate }}</ng-template>
        <ng-template #content let-step="step">
            <app-part-number-details-form [showValidations]="step.nextTriggered" [mode]="mode">
            </app-part-number-details-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canContinue]="isWizardOpened && partNumberLinesValid && !isDataLoading">
        <ng-template #title>{{ 'admin.partNumbers.form.sections.lines' | translate }}</ng-template>
        <ng-template #content let-step="step">
            <app-part-number-lines-form [showValidations]="step.nextTriggered"
                                        [mode]="mode"
                                        [lines]="lines">
            </app-part-number-lines-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canContinue]="isWizardOpened && !isDataLoading" *ngIf="showSPI()">
        <ng-template #title>{{ 'admin.partNumbers.form.sections.insertionCycles' | translate }}</ng-template>
        <ng-template #content let-step="step">
            <app-part-number-insertion-cycles-form [showValidations]="step.nextTriggered"
                                                   [mode]="mode"
                                                   [insertionCycles]="insertionCycles">
            </app-part-number-insertion-cycles-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canContinue]="isWizardOpened && partNumberEquipmentsValid && !isDataLoading">
        <ng-template #title>{{ 'admin.partNumbers.form.sections.equipment' | translate }}</ng-template>
        <ng-template #content let-step="step">
            <app-part-number-equipment-form [showValidations]="step.nextTriggered"
                                            [mode]="mode"
                                            [equipments]="equipments">
            </app-part-number-equipment-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canContinue]="isWizardOpened && !isDataLoading">
        <ng-template #title>{{ 'admin.partNumbers.form.sections.equivalence' | translate }}</ng-template>
        <ng-template #content let-step="step">
            <app-part-number-equivalence-form [showValidations]="step.nextTriggered"
                                              [mode]="mode">
            </app-part-number-equivalence-form>
        </ng-template>
    </app-wizard-step>

    <app-wizard-step [canContinue]="isWizardOpened && !isDataToolsLoading">
        <ng-template #title>{{ 'admin.partNumbers.form.sections.tools' | translate }}</ng-template>
        <ng-template #content let-step="step">
            <app-part-number-tools-form [showValidations]="step.nextTriggered"
                                        [tools]="tools"
                                        [toolConfig]="toolConfig"
                                        [selectedTools]="selectedTools"
                                        [selectedToolsConfig]="selectedToolsConfig"
                                        [loading] = isDataToolsLoading
                                        [mode]="mode"
                                        (toolsFilterChange)="getTools($event)"
                                        (toolsSortChange)="getTools($event)"
                                        (toolsGroupChange)="getTools($event)"
                                        (toolsPageChange)="getTools($event)">
            </app-part-number-tools-form>
        </ng-template>
    </app-wizard-step>

    <app-wizard-step>
        <ng-template #title>{{ 'admin.partNumbers.form.sections.overview' | translate }}</ng-template>
        <ng-template #content let-step="step">
            <app-partnumber-overview [mode]="mode"></app-partnumber-overview>
        </ng-template>
    </app-wizard-step>
</app-wizard-modal>
